/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListIssuedCardsGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type ListIssuedCardsRequest = {
  /**
   * The Moov business account for which the cards have been issued.
   */
  accountID: string;
  skip?: number | undefined;
  count?: number | undefined;
  /**
   * Optional, comma-separated states to filter the Moov list issued cards response. For example `active,pending-verification`
   */
  states?: Array<components.IssuedCardState> | undefined;
};

export type ListIssuedCardsResponse = {
  headers: { [k: string]: Array<string> };
  result: Array<components.IssuedCard>;
};

/** @internal */
export const ListIssuedCardsGlobals$inboundSchema: z.ZodType<
  ListIssuedCardsGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type ListIssuedCardsGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const ListIssuedCardsGlobals$outboundSchema: z.ZodType<
  ListIssuedCardsGlobals$Outbound,
  z.ZodTypeDef,
  ListIssuedCardsGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function listIssuedCardsGlobalsToJSON(
  listIssuedCardsGlobals: ListIssuedCardsGlobals,
): string {
  return JSON.stringify(
    ListIssuedCardsGlobals$outboundSchema.parse(listIssuedCardsGlobals),
  );
}
export function listIssuedCardsGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<ListIssuedCardsGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListIssuedCardsGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListIssuedCardsGlobals' from JSON`,
  );
}

/** @internal */
export const ListIssuedCardsRequest$inboundSchema: z.ZodType<
  ListIssuedCardsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  accountID: z.string(),
  skip: z.number().int().optional(),
  count: z.number().int().optional(),
  states: z.array(components.IssuedCardState$inboundSchema).optional(),
});
/** @internal */
export type ListIssuedCardsRequest$Outbound = {
  accountID: string;
  skip?: number | undefined;
  count?: number | undefined;
  states?: Array<string> | undefined;
};

/** @internal */
export const ListIssuedCardsRequest$outboundSchema: z.ZodType<
  ListIssuedCardsRequest$Outbound,
  z.ZodTypeDef,
  ListIssuedCardsRequest
> = z.object({
  accountID: z.string(),
  skip: z.number().int().optional(),
  count: z.number().int().optional(),
  states: z.array(components.IssuedCardState$outboundSchema).optional(),
});

export function listIssuedCardsRequestToJSON(
  listIssuedCardsRequest: ListIssuedCardsRequest,
): string {
  return JSON.stringify(
    ListIssuedCardsRequest$outboundSchema.parse(listIssuedCardsRequest),
  );
}
export function listIssuedCardsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListIssuedCardsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListIssuedCardsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListIssuedCardsRequest' from JSON`,
  );
}

/** @internal */
export const ListIssuedCardsResponse$inboundSchema: z.ZodType<
  ListIssuedCardsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: z.array(components.IssuedCard$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type ListIssuedCardsResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: Array<components.IssuedCard$Outbound>;
};

/** @internal */
export const ListIssuedCardsResponse$outboundSchema: z.ZodType<
  ListIssuedCardsResponse$Outbound,
  z.ZodTypeDef,
  ListIssuedCardsResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: z.array(components.IssuedCard$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function listIssuedCardsResponseToJSON(
  listIssuedCardsResponse: ListIssuedCardsResponse,
): string {
  return JSON.stringify(
    ListIssuedCardsResponse$outboundSchema.parse(listIssuedCardsResponse),
  );
}
export function listIssuedCardsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListIssuedCardsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListIssuedCardsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListIssuedCardsResponse' from JSON`,
  );
}
